module.exports = __webpack_public_path__ + "img/board_layout_5.24f28ef4.png";